import { PERMISSIONS } from "@/constants";

export default [
    {
        name: "chatbot",
        meta: {
            title: "Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot",
        component: () => import("@/views/pages/chatbot/index.vue"),
    },
    {
        name: "chatbot-candidate-sessions",
        meta: {
            title: "Select Chat Session - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/sessions",
        component: () => import("@/views/pages/chatbot/candidateSessions.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-files",
        meta: {
            title: "Select Files - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/files",
        component: () => import("@/views/pages/chatbot/candidateFiles.vue"),
        props: true
    },
    {
        name: "chatbot-upload",
        meta: {
            title: "Upload File - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/upload",
        component: () => import("@/views/pages/chatbot/upload.vue"),
        props: true
    },
    {
        name: "chatbot-chat-session",
        meta: {
            title: "Chat Session - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/session/:sessionId",
        component: () => import("@/views/pages/chatbot/chatSession.vue"),
        props: true
    },
    {
        name: "chatbot-file-details",
        meta: {
            title: "File Details - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/file/:fileId",
        component: () => import("@/views/pages/chatbot/fileDetails.vue"),
        props: true
    },
    {
        name: "chatbot-report-details",
        meta: {
            title: "Report Details - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/file/:fileId/report",
        component: () => import("@/views/pages/chatbot/reportDetails.vue"),
        props: true
    }
]